import DashboardTable from "./components/Dashboard/Table.vue"
import GroupSelector from "./components/Dashboard/GroupSelector.vue"
import CompanyGroupsTable from "./components/CompanyGroups/Table.vue"
import UserGroupsTable from "./components/UserGroups/Table.vue"

import Vue from 'vue';
import Vuetify from '@lzhoucs/vuetify';
import VueShopifyDraggable from 'vue-shopify-draggable'
import Fragment from 'vue-fragment'
Vue.use(Fragment.Plugin)
Vue.use(VueShopifyDraggable)
Vue.use(Vuetify);

//Register Vue components
Vue.component('GroupSelector', GroupSelector);
Vue.component('DashboardTable', DashboardTable);
Vue.component('CompanyGroupsTable', CompanyGroupsTable);
Vue.component('UserGroupsTable', UserGroupsTable);

let handleOutsideClick;

Vue.directive('clickAway', {
    // for click away events
    bind(el, binding, vnode) {
        // Here's the click/touchstart handler
        // (it is registered below)
        handleOutsideClick = (e) => {
            e.stopPropagation();
            // Get the handler method name and the exclude array
            // from the object used in v-closable
            const { handler, exclude } = binding.value;
            // This variable indicates if the clicked element is excluded
            let clickedOnExcludedEl = false;
            exclude.forEach((refName) => {
                // We only run this code if we haven't detected
                // any excluded element yet
                if (!clickedOnExcludedEl) {
                    clickedOnExcludedEl = e.target.classList.value.includes(refName);
                }
            });
            // We check to see if the clicked element is not
            // the dialog element and not excluded
            if (!el.contains(e.target) && !clickedOnExcludedEl) {
                // If the clicked element is outside the dialog
                // and not the button, then call the outside-click handler
                // from the same component this directive is used in
                vnode.context[handler]();
            }
        };
        // Register click/touchstart event listeners on the whole page
        document.addEventListener("click", handleOutsideClick);
        document.addEventListener("touchstart", handleOutsideClick);
    },
    unbind() {
        // If the element that has v-closable is removed, then
        // unbind click/touchstart listeners from the whole page
        document.removeEventListener("click", handleOutsideClick);
        document.removeEventListener("touchstart", handleOutsideClick);
    },
})

//Create eventbus as instance property 
Vue.prototype.$eventBus = new Vue();

let isDashboard = window.location.href.includes('dashboard');
let isCompaniesGroup = window.location.href.includes('companies/groups') ;
let isUsersGroup = window.location.href.includes('users/groups');

//Render vue instance
if(isDashboard || isCompaniesGroup || isUsersGroup){
var vm = new Vue({
    el: isDashboard ? '#dashboard-table' : isCompaniesGroup? '#companies-group-table' : '#users-group-table'
});
}
require('./bootstrap');

require("./theme_scripts/app");

require("jquery-pjax");

$(document).on('pjax:complete', () => {
    isDashboard = window.location.href.includes('dashboard');
    isCompaniesGroup = window.location.href.includes('companies/groups') ;
    isUsersGroup = window.location.href.includes('users/groups');

    if(isDashboard || isCompaniesGroup || isUsersGroup){
        var vm = new Vue({
            el: isDashboard ? '#dashboard-table' : isCompaniesGroup? '#companies-group-table' : '#users-group-table'
        });
        }
});

if (isDashboard) {
    $('.isDashboard').show();   
}

require('./dashboard/admin/export-table.js');

require("../non_npm/bootstrap-material-design/dist/bootstrap-material-design.iife.js");
require("moment");
require("peity");
require("mousetrap");
require("sweetalert2");
require("jquery-fullscreen-plugin");
require("jquery-ui/jquery-ui");
require("select2");
require("jquery.fakeloader");
require('@chenfengyuan/datepicker');

require("datatables.net/js/jquery.dataTables");
require("datatables.net-responsive/js/dataTables.responsive");
require('datatables.net-colreorder/js/dataTables.colReorder');
require("sweetalert2");

require('../non_npm/jquery-ui/datepicker/datepicker-da.js');
require('../non_npm/jquery-ui/datepicker/datepicker-en-GB.js');
require('../non_npm/jquery-ui-month-picker/src/MonthPicker');
require('x-editable/dist/jqueryui-editable/js/jqueryui-editable');

require("powerbi-client");
require("../non_npm/bootstrap-material-datetimepicker/js/bootstrap-material-datetimepicker");

require("./functions");
require("./jquery-functions-library");

require("./theme_scripts/elements/navbar-2");
require("./users-table");
require("./theme_scripts/ui/tooltips");
require("./theme_scripts/ui/popovers");

require("datatables.net");
require("datatables.net-searchpanes-dt");
require( 'datatables.net-datetime' );
require("datatables.net-buttons");
require("datatables.net-buttons/js/dataTables.buttons");
require("datatables.net-buttons/js/buttons.flash");
require("pdfmake/build/pdfmake");
require("imports-loader?this=>window!pdfmake/build/vfs_fonts");
require("datatables.net-buttons/js/buttons.colVis");
require("datatables.net-buttons/js/buttons.html5");
require("datatables.net-buttons/js/buttons.print");
require("jszip/dist/jszip");

require("../non_npm/datatables/Select/dataTables.select.min");

require("jquery-datatables-checkboxes");
require("jquery-confirm");
require("datatables.net-plugins/sorting/datetime-moment");

require("@nobleclem/jquery-multiselect");

require("./pjax-function-load");

require("./custom-approve");
//Vouchers
require("./voucher/clear-all");
require("./voucher/close-period");
require("./voucher/close-selected-vouchers");
require("./voucher/delete-selected-vouchers");
require("./voucher/ignore-selected-vouchers");
require("./voucher/release-all");
require("./voucher/remove-selected-vouchers");
require("./voucher/upload-pdf");
require("./voucher/upload-selected-vouchers");
require("./voucher/upload-statement");
require("./voucher/voucher-table");
require("./voucher/vouchers-earlier-releases-actions");
require("./voucher/vouchers-earlier-releases-table");

//Companies
require("./companies/save-customer-number");
require("./companies/companies-table");

//General
require("./profile-picture");
require("./highlight-active-page");
require("./sidebar-listener");
require("./edit_user");
require("./keyboard");

//User companies
require("./user-companies/user-companies");

//BI Companies
require("./bi-companies/bi-companies");

//Dashboard
require("./dashboard/dashboard-task-table");
require("./dashboard/dashboard-procedures-table");
require("./dashboard/dashboard-voucher-table");
require("./dashboard/dashboard");

//Dashboard Admin
require('./dashboard/admin/db-v2-all-table.js');
require('./dashboard/admin/db-cache.js');
require('./dashboard/admin/db-reload-on-demand.js');
require('./dashboard/admin/db-month-picker.js');
require('./dashboard/admin/db-global-search.js');
require('./dashboard/admin/db-dropdown-fix.js');

//Salary
require('./salary/customer-employees_table.js');
require('./salary/customer-employees_steps_validation.js');
require('./salary/customer-employees_disco_codes.js');
require('./salary/customer-employees_terminate.js');
require('./salary/customer-employees_create_new.js');
require('./salary/payroll-data_table.js');
require('./salary/payroll-index.js');
require('./salary/payroll-navigation.js');
require('./salary/payroll-download-excel.js');
require('./salary/payroll-approval.js');
require('./salary/payroll-unlock.js');
require('./salary/payroll-calc-amount.js');
require('./salary/employees-download-csv.js');
require('./salary/pay_slips-table.js');
require('./salary/pay_slips-delete.js');
require('./salary/pay_slips-approve.js');
require('./salary/pay_slips-upload.js');
require('./salary/pay_slips-send-reminder.js');
require('./salary/payroll-status.js');
require('./salary/fields-company-table.js');
require('./salary/employee-changes.js');
require('./salary/employee-changes-export.js');
require('./salary/postal-code-autosuggest.js');
require('./salary/customer-employees_postal_codes.js');
require('./salary/company-salary-settings.js');

//System
require('./system/datafields.js');
require('./system/vat-deadlines.js');
require('./system/save-dropbox-config.js');

//Holidays
require('./holidays/holidays-table.js');
require('./holidays/actions.js');

//Work calendars
require('./work-calendars/work-calendars-table.js');
require('./work-calendars/actions.js');

//Task templates
require('./task-templates/task-templates-table.js');
require('./task-templates/actions.js');

//Company
require('./company/employees-optionals/employees-optionals-table.js');
require('./company/employees-optionals/actions.js');

//Kube
require('./kube/data-fields-table.js');
require('./kube/actions.js');

//Roles
require('./roles/roles-table.js');
require('./roles/actions.js');

//Economic period
require("./economic-period/period-table");

//Translation
require("./translation/manager");

//General
require('./employee-settings.js');
require('./table-settings.js');
require('./powerbi/powerbi.js');
require('./roger-ai/roger-ai.js');
require('./cvr.js');



